module.exports = __webpack_public_path__ + "img/ab-securite-mobile.2ccf94b.jpg";